<template>
  <div v-if="!accepted" class="cookie-banner">
    <div class="cookie-container">
      <p class="cookie-text">
        Мы используем файлы cookie и аналогичные технологии для обеспечения
        работы сайта, аналитики и улучшения пользовательского опыта. Подробнее —
        в
        <a href="/privacy" target="_blank"> Политике конфиденциальности </a>.
      </p>

      <div class="cookie-actions">
        <button class="btn btn-secondary" @click="acceptNecessary">
          Только необходимые
        </button>

        <button class="btn btn-primary" @click="acceptAll">Принять все</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieBanner",
  data() {
    return {
      accepted: false,
    };
  },
  mounted() {
    const consent = localStorage.getItem("cookie_consent");
    if (consent) {
      this.accepted = true;
    }
  },
  methods: {
    acceptNecessary() {
      localStorage.setItem("cookie_consent", "necessary");
      this.accepted = true;
      this.logConsent("necessary");
    },
    acceptAll() {
      localStorage.setItem("cookie_consent", "all");
      this.accepted = true;
      this.logConsent("all");
      this.$emit("enable-analytics");
    },
    logConsent(type) {
      fetch("/api/cookie-consent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          consent: type,
          timestamp: new Date().toISOString(),
        }),
      });
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #e5e5e5;
  box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.06);
  padding: 24px;
  z-index: 1000;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.cookie-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.cookie-text {
  flex: 1 1 600px;
  font-size: 14px;
  line-height: 1.6;
  color: #121017;
  margin: 0;
}

.cookie-text a {
  color: #121017;
  text-decoration: underline;
}

.cookie-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.btn {
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.btn-primary {
  background: #121017;
  color: #ffffff;
}

.btn-primary:hover {
  background: #2a2730;
}

.btn-secondary {
  background: #ffffff;
  color: #121017;
  border: 1px solid #dcdcdc;
}

.btn-secondary:hover {
  background: #f6f6f6;
}
</style>
